<template>
  <v-container class="inner-main pt-2 mb-10">
    <v-row class="mt-3">
      <v-col cols="" md="3">
        <v-card color="default" elevation="0">
          <v-card-title>
            <div class="title">
              {{$t('global.menu.account.subs')}}
            </div>
          </v-card-title>

          <v-card-text class="subscriptions-nav">
            <a @click="navObj = 'overview'" class="d-block" :class="{ 'clickable': navObj != 'overview' }"
              :style="[navObj != 'overview' ? 'text-decoration:none;color:black !important' : '']"> {{$t('shop.subscription.tab.overview')}}</a>

            <a @click="navObj = 'upgrade'" class="d-block" :class="{ 'clickable': navObj != 'upgrade' }"
              :style="[navObj != 'upgrade' ? 'text-decoration:none;color:black !important' : '']"> {{$t('shop.subscription.tab.upgrade')}}</a>
          </v-card-text>
        </v-card>

      </v-col>
      <v-col md="9">
        <div v-if="navObj == 'overview'">
          <p v-html="translatedText"></p>
        </div>
        <v-container fluid v-else max-width="600px" class="text-left ma-0">
          <div style="font-size:x-large;font-weight:700" v-html="$t('shop.subscription.upgrade.free.title1')"></div>
          <div class="mt-4">
            <span v-html="$t('shop.subscription.upgrade.free.text1')"></span>
          </div>
          <div class="mt-4">

            <span class="mt-4" v-html="$t('shop.subscription.upgrade.free.text2')"></span>
          </div>
          <div class="mt-4">

            <span class="mt-4" v-html="$t('shop.subscription.upgrade.free.text3')">
            </span>
          </div>
          <v-btn variant="flat" size="large" color="primary" rounded="xl"
            class="white--text w-100 find-favourites-button mt-3">{{$t('shop.subscription.upgrade.free.button')}}</v-btn>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getCurrentInstance, ref, computed } from 'vue';

export default {
  components: {
  },
  setup() {
    // const showSheet = ref(false);
    const config = {
      itemsToShow: 3
    }
    const navObj = ref('upgrade')
    const openText = ref(false);
    const toggleText = () => {
      openText.value = !openText.value; // Toggle the open state
    }
    const { proxy } = getCurrentInstance();

    const translatedText = computed(() => proxy.$t('shop.subscription.overview.text', {name: proxy.$user.value.shopData.name},{ raw: true }));
    return {
      // showSheet:false,
      config,
      openText,
      toggleText,
      navObj,
      translatedText
    };
  },

  data() {
    return {
      showSheet: false,
      items: [
        "Kundenmagnet",
        "Image Booster",
        "Must-Have",
        "Geheimtipp",
        "Margen-Held",
        "PR-Star",
        "Kundenliebling",
        "Durchstarter",
      ],
      images: [
        "https://picsum.photos/200/300", "https://picsum.photos/300/300", "https://picsum.photos/500/300"
      ]
    }
  },
};
</script>

<style scoped>
.inner-main {
  margin-left: auto;
  margin-right: auto;
  max-width: 1170px;
}

.description-wrapper {
  position: relative;
}

.title {
  font-size: 24px;
  margin-bottom: 15px;
  white-space: normal;
}

.subscriptions-nav a {
  font-size: 18px;
  margin-bottom: 10px;
  text-decoration: none;
}

.subscriptions-nav a:hover {
  color: unset;
}

.description-text {
  display: block;
  max-height: 200px;
  /* Adjust the height based on your design */
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  transition: max-height 0.3s ease-in-out;
  font-size: 14px;
}

.description-text.truncated {
  max-height: 200px;
  /* Limit text height when truncated */
}

.description-text:not(.truncated) {
  max-height: none;
  /* Allow full text to show when toggled */
}

.text-link {
  text-decoration: none;
  color: #1e88e5;
  cursor: pointer;
  float: right;
}

.text-link:hover {
  text-decoration: underline;
}
</style>

<style>
/*.dialog-list-item {
    min-height: 30px !important;
    background-color: transparent !important;
  }
  
  */


.share-hint,
.descrption-text {
  font-size: 14px !important;
}

h1 {
  font-size: 36px !important;
  ;
}

h4 {
  font-size: 16px !important;
  font-weight: 700;
}

.f-16 {
  font-size: 16px !important;
}

.edit-btn {
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 1;
}

.logo-sheet {
  background-image: url('https://d2v01xjmjw73dt.cloudfront.net/api/image/collection/6cc5fce5-d423-4af3-8bf8-e5d25a234e80/AVATAR');
  background-size: cover;
}
</style>